import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import NursingRecordList from "../pages/Phase-05/NursingRecord/NursingRecordList";
import {
    fetchNursingRecords,
    deleteNursingRecord,
} from "../store/slices/nursingRecordsSlice"; // Adjust path
import { selectHasPermission } from "../store/slices/authSlice";

const NursingRecords = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { nursingRecords, isLoading, error } = useSelector((state) => state.nursingRecords);

    // Permissions
    const canManage = useSelector((state) =>
        selectHasPermission(state, "nursing-record-manage")
    );
    const canCreate = useSelector((state) =>
        selectHasPermission(state, "nursing-record-create")
    );
    const canEdit = useSelector((state) =>
        selectHasPermission(state, "nursing-record-edit")
    );
    const canDelete = useSelector((state) =>
        selectHasPermission(state, "nursing-record-delete")
    );

    // Fetch all records
    useEffect(() => {
        dispatch(fetchNursingRecords());
    }, [dispatch]);

    // Routing
    const handleAdd = () => navigate("/phase05/nursing-records/add");
    const handleEdit = (id) => navigate(`/phase05/nursing-records/edit/${id}`);

    // Delete
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This Nursing Record will be deleted permanently!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            dispatch(deleteNursingRecord(id));
            Swal.fire("Deleted!", "Record has been removed.", "success");
        }
    };

    if (!canManage)
        return (
            <Navigate
                to="/dashboard"
                state={{ error: "You do not have permission to manage Nursing Records." }}
                replace
            />
        );

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                {error && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <strong>Error:</strong> {error}
                        <button type="button" className="btn-close" onClick={() => { }}></button>
                    </div>
                )}

                <div className="card">
                    <div className="card-body">
                        <NursingRecordList
                            records={nursingRecords}
                            loading={isLoading}
                            onAdd={canCreate ? handleAdd : null}
                            onEdit={canEdit ? handleEdit : null}
                            onDelete={canDelete ? handleDelete : null}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default NursingRecords;
